import type { Arrayable, MaybeComputedElementRef, MaybeElement } from '@vueuse/core';
import { tryOnScopeDispose, unrefElement } from '@vueuse/core';
import $ from 'jquery';
import { watch } from 'vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type JqueryEventListener = (this: HTMLElement, event: JQuery.Event | JQueryEventObject, ...data: any) => unknown;
export default function useJqueryEventListener(
    target: MaybeComputedElementRef<MaybeElement> | undefined,
    event: Arrayable<string>,
    listener: JqueryEventListener,
) {
    const events: string[] = Array.isArray(event) ? event : [event];

    const cleanup = () => {
        const el = unrefElement(target);
        if(el) {
            for(const e of events) {
                $(el).off(e, listener);
            }
        }
    };

    const stopWatch = watch(() => unrefElement(target), () => {
        cleanup();
        const el = unrefElement(target);
        if(el) {
            for(const e of events) {
                $(el).on(e, listener);
            }
        }
    }, { immediate: true, flush: 'post' });

    const stop = () => {
        stopWatch();
        cleanup();
    };

    tryOnScopeDispose(stop);

    return stop;
}
